(function () {
  if (document.body.classList.contains('template-cart')) return;

  var busy = false;
  var strings = {
    error: 'No pudimos actualizar la bolsa de regalo. Inténtalo de nuevo.'
  };
  var stringsNode = document.querySelector('[data-rd-drawer-strings]');
  if (stringsNode) {
    try {
      strings = JSON.parse(stringsNode.textContent);
    } catch (error) {}
  }

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function getCart() {
    return fetch(rootUrl() + 'cart.js').then(function (response) {
      return response.json();
    });
  }

  function isGiftLine(item) {
    return item.properties && item.properties._is_gift_bag === 'true';
  }

  function garmentUnits(cart) {
    return cart.items.reduce(function (total, item) {
      return isGiftLine(item) ? total : total + item.quantity;
    }, 0);
  }

  function showError(message) {
    var error = document.querySelector('[data-rd-drawer-gift-error]');
    if (!error) return;
    error.textContent = message || strings.error;
    error.hidden = false;
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        drawer.renderContents({ sections: sections });
      });
  }

  // A single bag line per cart. Changing the size keeps "Una por prenda" (one bag per garment) if it was chosen in the cart page.
  function setGiftBag(variantId) {
    return getCart().then(function (cart) {
      var updates = {};
      var perGarment = false;
      cart.items.forEach(function (item) {
        if (!isGiftLine(item)) return;
        updates[item.key] = 0;
        if (item.properties._gift_for_item === 'each') perGarment = true;
      });
      var body = { updates: updates };
      if (!variantId) body.note = '';

      var cleared = Object.keys(updates).length || !variantId
        ? postJSON(rootUrl() + 'cart/update.js', body)
        : Promise.resolve();

      var units = garmentUnits(cart);
      return cleared.then(function () {
        if (!variantId || units === 0) return getCart();
        return postJSON(rootUrl() + 'cart/add.js', {
          items: [
            {
              id: Number(variantId),
              quantity: perGarment ? units : 1,
              properties: { _is_gift_bag: 'true', _gift_for_item: perGarment ? 'each' : 'pedido' }
            }
          ]
        }).then(getCart);
      });
    });
  }

  function syncPerGarmentBag(cart) {
    if (busy || !cart || !Array.isArray(cart.items)) return;
    var bags = cart.items.filter(function (item) {
      return isGiftLine(item) && item.properties._gift_for_item === 'each';
    });
    var units = garmentUnits(cart);
    if (bags.length !== 1 || units === 0 || bags[0].quantity === units) return;

    busy = true;
    postJSON(rootUrl() + 'cart/change.js', { id: bags[0].key, quantity: units })
      .then(refreshDrawer)
      .catch(function () {})
      .finally(function () {
        busy = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && (event.cartData || event.cart_data);
      if (cart && Array.isArray(cart.items)) syncPerGarmentBag(cart);
      else getCart().then(syncPerGarmentBag);
    });
  }

  function applyGift(control, variantId) {
    busy = true;
    var gift = control.closest('[data-rd-drawer-gift]');
    if (gift) gift.classList.add('is-loading');

    return setGiftBag(variantId)
      .then(refreshDrawer)
      .catch(function (error) {
        if (control.type === 'checkbox') control.checked = !control.checked;
        showError(error && error.description);
      })
      .finally(function () {
        busy = false;
        if (gift) gift.classList.remove('is-loading');
      });
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-rd-drawer-gift] [data-rd-gift-toggle]');
    if (!toggle || !toggle.closest('cart-drawer')) return;
    if (busy) {
      toggle.checked = !toggle.checked;
      return;
    }
    applyGift(toggle, toggle.checked ? toggle.dataset.variantId : null);
  });

  document.addEventListener('click', function (event) {
    var size = event.target.closest('[data-rd-drawer-gift] [data-rd-gift-size]');
    if (!size || busy || size.classList.contains('is-active')) return;
    if (!size.closest('cart-drawer')) return;
    applyGift(size, size.dataset.variantId);
  });
})();
